import { Controller } from "@hotwired/stimulus"

export default class NewController extends Controller {
  static targets = ["submitButton", "initialMessageCard", "validationError", "nameField", "initialMessageDefined"]

  declare submitButtonTarget: HTMLButtonElement
  declare initialMessageCardTarget: HTMLElement
  declare validationErrorTarget: HTMLElement
  declare nameFieldTarget: HTMLInputElement
  declare initialMessageDefinedTarget: HTMLInputElement
  declare hasValidationErrorTarget: boolean
  declare hasInitialMessageDefinedTarget: boolean

  connect() {
    this.updateSubmitButtonState()
  }

  initialMessageDefinedTargetConnected() {
    this.updateSubmitButtonState()
  }

  get initialMessageDefined(): boolean {
    return this.hasInitialMessageDefinedTarget && this.initialMessageDefinedTarget.value === "true"
  }

  validateBeforeSubmit(event: Event) {
    if (!this.initialMessageDefined) {
      event.preventDefault()

      if (this.hasValidationErrorTarget) {
        this.validationErrorTarget.classList.remove("d-none")
      }

      this.initialMessageCardTarget.scrollIntoView({ behavior: "smooth", block: "center" })

      return false
    }

    return true
  }

  removeValidationError() {
    if (this.hasValidationErrorTarget) {
      this.validationErrorTarget.classList.add("d-none")
    }
  }

  updateSubmitButtonState() {
    const nameValid = this.nameFieldTarget.value.trim().length > 0
    this.submitButtonTarget.disabled = !(nameValid && this.initialMessageDefined)
  }
}
